import { api } from "./client.js";

export type Level = "exact" | "city" | "country" | "hidden";

export interface Circle {
  id: string;
  name: string;
  visibility: Level;
  color: string | null;
}

interface ConfirmEnvelope {
  needsConfirm?: boolean;
  from?: Level;
  to?: Level;
  affects?: number;
}

export const circlesApi = {
  list: () => api.get<{ circles: Circle[] }>("/api/circles"),
  create: (name: string, visibility: Level) =>
    api.post<{ id: string }>("/api/circles", { name, visibility }),
  setVisibility: (id: string, visibility: Level, confirm = false) =>
    api.patch<ConfirmEnvelope>(`/api/circles/${id}`, { visibility, confirm }),
  remove: (id: string) => api.del<{ deleted: boolean }>(`/api/circles/${id}`),
  members: (id: string) =>
    api.get<{ members: { id: string; name: string; handle: string | null }[] }>(
      `/api/circles/${id}/members`,
    ),
  addMember: (id: string, userId: string, confirm = false) =>
    api.put<ConfirmEnvelope>(`/api/circles/${id}/members/${userId}`, { confirm }),
  removeMember: (id: string, userId: string) =>
    api.del<{ removed: boolean }>(`/api/circles/${id}/members/${userId}`),
};

export const meApi = {
  setDefault: (level: Level, confirm = false) =>
    api.patch<ConfirmEnvelope>("/api/me/visibility", { level, confirm }),
  audience: () => api.get<{ audience: Record<Level, number>; total: number }>("/api/me/audience"),
};
